/**
 * TanStack Query hooks for `brand-color-logo-uploader`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	brandColorLogoUploaderQueryKeys,
	type CreateBrandColorLogoUploaderBody,
	type ListBrandColorLogoUploaderResponse,
	type BrandColorLogoUploaderRow,
} from "./api";

export function useBrandColorLogoUploaderList(): UseQueryResult<ListBrandColorLogoUploaderResponse, Error> {
	return useQuery({
		queryKey: brandColorLogoUploaderQueryKeys.list(),
		queryFn: list,
	});
}

export function useBrandColorLogoUploaderCreate(): UseMutationResult<BrandColorLogoUploaderRow, Error, CreateBrandColorLogoUploaderBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: brandColorLogoUploaderQueryKeys.all });
		},
	});
}

export function useBrandColorLogoUploaderDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: brandColorLogoUploaderQueryKeys.all });
		},
	});
}
